<template>
  <div class="buy-now">
    <section class="buy-now__container">
      <AppTitle
        :data="currentData.title"
        class="buy-now__title"
      />
      <h2 class="buy-now__subtitle" data-anim="subtitle">{{ currentData.subtitle }}</h2>
      <p class="buy-now__caption" data-anim="caption" v-html="currentData.caption"></p>
      <div
        class="buy-now__link buy-now__link--dsk button--dsk"
        data-anim="button"
      >
        <a
          @mouseenter.prevent="cursorToScroll()"
          @mouseleave.prevent="cursorToClose()"
          :href="currentData.link"
          target="_blank"
          rel="noopener"
        >
          <span class="buy-now__link-caption button__caption">Buy Now</span>
          <span class="buy-now__arrow button__arrow">
            ›
          </span>
        </a>
      </div>
      <div class="buy-now__link buy-now__link--mbl button--mbl" data-anim="button">
        <a
          :href="currentData.link"
          aria-label="buy now"
          target="_blank"
          rel="noopener"
        >
          <span class="buy-now__link-caption button__caption">Buy Now</span>
          <span class="buy-now__arrow button__arrow">
            ›
          </span>
        </a>
      </div>
    </section>
  </div>
</template>

<script>
import Apollo from '@adoratorio/apollo';
import Cursor from '@/scripts/Cursor';

import AppTitle from '@/components/AppTitle.vue';


export default {
  name: 'buyNow',

  components: {
    AppTitle,
  },

  computed: {
    currentData() {
      const content = this.$store.state.content; // eslint-disable-line
      return content.find(page => page.index === content.length - 1).content;
    },
  },

  mounted() {
    this.$eventHub.$emit('cursorToScroll');
    if (!this.$store.state.scrollIsLocked) this.$store.commit('SET_STATE_LOCK_SCROLLING', true);


    if (Cursor.ref !== null) {
      this.ctaAdded = true;
      Cursor.ref.addTargets([{
        id: 'apollo-page-cta',
        elements: Array.from(document.querySelectorAll('.button--dsk .button__arrow')),
        magnetism: {
          mode: Apollo.MODE.PULL,
          easing: {
            mode: Apollo.EASING.OUT_CUBIC,
            duration: 300,
          },
        },
      }]);
    }
  },

  methods: {
    cursorToScroll() {
      this.$eventHub.$emit('soundInteraction');
      this.$eventHub.$emit('cursorToZoom');
    },

    cursorToClose() {
      this.$eventHub.$emit('cursorToScroll');
    },
  },
};
</script>

<style lang="scss" scoped>
.buy-now__title,
.buy-now__caption,
.buy-now__subtitle {
  grid-column-start: 4;
  grid-column-end: 13;
  text-align: center;

  @include mq(ipadL) {
    grid-column-start: 13;
    grid-column-end: 26;
    text-align: left;
  }
}

.buy-now__container {
  @include mq($until: ipadL) {
    height: 90vh;
    padding: 80px 0 160px;
    box-sizing: border-box;
    align-items: center;

    .buy-now__title {
      align-self: flex-end;
    }

    .buy-now__caption {
      align-self: flex-start;
      line-height: 1.1;
    }

    .buy-now__link a .buy-now__link-caption {
      font-size: font-size(m);
    }
  }

  .buy-now__subtitle {
    @include mq(ipadL) {
      margin-top: 30px;
    }

    @include fluid-type(
      375px,
      1920px,
      20px,
      60px,
      25px,
      75px
    );
  }

  .buy-now__caption {
    @include mq(ipadL) {
      margin: 30px 0 0;
      font-size: font-size(xs);
      line-height: 1.4;
    }
  }

  .buy-now__link {
    position: relative;
    margin-top: 0;

    grid-column-start: 4;
    grid-column-end: 13;
    text-align: center;

    @include mq(ipadL) {
      margin-top: 30px;

      grid-column-start: 13;
      grid-column-end: 26;
      text-align: left;
    }

    & > a {
      margin-top: 40px;

      background: transparent;
      border: none;
      font-size: font-size(xs);
      color: $color-primary;

      cursor: pointer;

      &:focus {
        outline: transparent;
      }
    }
  }

  .buy-now__link--dsk {
    @include mq($and: $is-touch-device) {
      @include visually-hidden;
    }
  }

  .buy-now__link--mbl {
    @include mq($and: $is-not-touch-device) {
      @include visually-hidden;
    }

    & .buy-now__arrow::before {
      content: '';

      position: absolute;
      width: 50px;
      height: 50px;
      top: 50%;
      left: 50%;

      background-image: url('/img/svg/cursor.svg');
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;

      transform: translateX(-50%) translateY(-50%);
    }
  }

  .buy-now__arrow {
    display: block;
    margin-top: 20px;
    padding: 20px;

    @include mq(ipadL) {
      display: inline-block;
      margin-top: 0;
      padding: 10px 20px;
      background: none;
    }

    font-size: font-size(xxs);
  }

  @include mq($and: $is-not-touch-device) {
    .buy-now__link-caption {
      position: relative;

      &::before {
        content: '';

        position: absolute;
        bottom: -5px;
        left: 0;
        width: 100%;
        height: 1px;

        background-color: $color-primary;

        transform: scaleX(0);
        transform-origin: 0% 50%;
        transition: transform 0.5s $inOutQuint,
      }
    }

    .buy-now__link a:hover .buy-now__link-caption::before {
      transform: scaleX(1);
    }
  }
}
</style>
